/**
 * Módulo para efectos de scroll
 * Controla los efectos visuales al hacer scroll en la página
 * Este módulo se auto-inicializa cuando el DOM está listo
 */

(function() {
    'use strict';
    
    /**
     * Inicializa los efectos de scroll para el header
     */
    function initScrollEffects() {
        const header = document.querySelector('.site-header') || document.querySelector('.site-header-mobile');
        let lastScrollTop = 0;
        
        if (!header) return;
        
        window.addEventListener('scroll', function() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            
            // Header fixo após scroll
            if (scrollTop > 100) {
                header.classList.add('header-fixed');
            } else {
                header.classList.remove('header-fixed');
            }
            
            // Esconder/mostrar header ao rolar
            if (scrollTop > lastScrollTop && scrollTop > 200) {
                header.classList.add('header-hidden');
            } else {
                header.classList.remove('header-hidden');
            }
            
            lastScrollTop = scrollTop;
        });
    }
    
    // Inicializar cuando el DOM esté listo
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initScrollEffects);
    } else {
        initScrollEffects();
    }
})();
